function ifNumber(v, otherwise) {
    return typeof v === 'number' ? v : otherwise;
}

export default class PackLearnProgress {
    constructor(view, json) {
        this.view = view;
        this.ignoreWriteForStatus = false;
        this.ignoreSelectForStatus = false;

        const jsonCards = 'cards' in json && json.cards ? json.cards : [];
        this.cards = {};
        jsonCards.forEach(v => {
            this.cards[v.card] = v;
        });

        this.cardsChanges = [];
    }

    /**
     * register unknown cards and remove orphans
     * @param {Map<int, ?>} cards
     */
    validate(cards) {
        // remove orphans
        Object.keys(this.cards).forEach(key => {
            if (!(key in cards)) {
                delete this.cards[key];
            }
        });
        // add missed cards
        Object.keys(cards).forEach(key => {
            if (!(key in this.cards)) {
                this.cards[key] = {};
            }
        });
    }

    clear() {
        let newCards = {};
        Object.keys(this.cards).forEach(key => {
            newCards[key] = {};
        });
        this.cards = newCards;
        this.cardsChanges = [];

        this.updateView();
    }

    flushChanges() {
        const out = [];
        this.cardsChanges.forEach(key => {
            const data = {card: key};
            out.push($.extend(data, this.cards[key]));
        });
        this.cardsChanges = [];
        return out;
    }

    incrementSuccess(mode, card) {
        const data = this.cards[card] || {};
        const counters = data[mode] || {};
        counters.correct = ifNumber(counters.correct, 0) + 1;

        data[mode] = counters;
        this._updateCard(card, data);
    }

    _updateCard(card, data) {
        this.cards[card] = data;
        this.cardsChanges.push(card);
    }

    incrementFailure(mode, card) {
        const data = this.cards[card] || {};
        const counters = data[mode] || {};
        counters.failure = ifNumber(counters.failure, 0) + 1;

        data[mode] = counters;
        this._updateCard(card, data);
    }

    getBalance(mode, card) {
        return this.getCorrect(mode, card) - this.getFailures(mode, card);
    }

    getBalanceAll(card) {
        return this.getBalance('select', card) + this.getBalance('write', card);
    }

    getCorrect(mode, card) {
        if (card in this.cards) {
            const data = this.cards[card];
            const counters = data[mode] || {};
            return ifNumber(counters.correct, 0);
        }
        return 0;
    }

    getCorrectAll(card) {
        return this.getCorrect('select', card) + this.getCorrect('write', card);
    }

    getFailures(mode, card) {
        if (card in this.cards) {
            const data = this.cards[card];
            const counters = data[mode] || {};
            return ifNumber(counters.failure, 0);
        }
        return 0;
    }

    getFailuresAll(card) {
        return this.getFailures('select', card) + this.getFailures('write', card);
    }

    status() {
        const statusCards = this.getStatusMap();
        return {
            remaining: statusCards.remaining.length,
            familiar: statusCards.familiar.length,
            mastered: statusCards.mastered.length
        };
    }

    updateView() {
        const status = this.status();
        this.view.find('[data-bind=remaining]').text(status.remaining);
        this.view.find('[data-bind=familiar]').text(status.familiar);
        this.view.find('[data-bind=mastered]').text(status.mastered);
    }

    isAllMastered() {
        return undefined === Object.keys(this.cards)
            .map(card => parseInt(card))
            .find(card => this.getStatus(card) !== 'mastered');
    }

    /**
     * @return {{familiar: int[], mastered: int[], remaining: int[]}}
     */
    getStatusMap() {
        const out = {
            mastered: [],
            familiar: [],
            remaining: []
        };

        Object.keys(this.cards)
            .map(card => parseInt(card))
            .forEach(card => {
                const collection = out[this.getStatus(card)];
                collection.push(card);
            });

        return out;
    }

    /**
     *
     * @param {int} card
     * @return {string}
     */
    getStatus(card) {
        if (this.testIsMastered(card)) {
            return 'mastered';
        } else if (this.getCorrect('select', card) >= 2 || this.getCorrect('write', card) >= 2) {
            return 'familiar';
        } else {
            return 'remaining';
        }
    }

    /**
     * @private
     */
    testIsMastered(card) {
        const fn = (mode) => {
            return this.getBalance(mode, card) >= 2 && this.getCorrect(mode, card) >= 3
        };
        return (this.ignoreSelectForStatus || fn('select'))
            && (this.ignoreWriteForStatus || fn('write'));
    }

    save() {
        const data = {
            cards: []
        };

        Object.entries(this.cards).forEach(([key, entry]) => {
            const id = parseInt(key);

            entry.card = id;
            if (this.getCorrectAll(id) > 0 || this.getFailuresAll(id) > 0) {
                data.cards.push(entry);
            }
        });

        return data;
    }
}
